import { Button } from "@/components/ui/button";

const SignInButton = () => {
  return (
    <div className="mr-4">
      <a
        className="z-50 text-white rounded-full"
        href="/access-denied"
      >
        <Button variant="default" size="default">
          Login
        </Button>
      </a>
    </div>
  );
};

export default SignInButton;
